import Vue from "vue";
import Router from "vue-router";

// import Base from "@/components/Base.vue";
import PageContent from "@/components/PageContent.vue";
import ProductPage from "@/components/ProductPage.vue";
import MehrLeben2022Content from "@/components/MehrLeben2022Content.vue";
import RecipePage from "@/components/RecipePage.vue";

Vue.use(Router);

export default new Router({
  routes: [{
    path: "/unsere-rezepte/rezept-archiv/:autoitem",
    component: PageContent
  }, {
    path: "/unsere-rezepte/rezept-archiv",
    component: PageContent
  }, {
    path: "/unsere-rezepte",
    component: RecipePage
  }, {
    path: "/mehr-leben",
    component: MehrLeben2022Content
  },
  {
    path: "/unsere-rezepte/:current",
    component: RecipePage
  },
  {
    path: "/unsere-rezepte/:parent/:current",
    component: RecipePage
  },
  {
    path: "/produkte",
    component: ProductPage
  },
  {
    path: "/produkte/:current",
    component: ProductPage
  }, {
    path: "/produkte/:parent/:current",
    component: ProductPage
  }, {
    path: "/:parent/:current/:autoitem",
    component: PageContent
  }, {
    path: "/",
    redirect: '/startseite',
    component: PageContent

  },
   {
    path: "/:current",
    component: PageContent},
  {
    path: "/:parent/:current",
    component: PageContent
  }
  ]
});